const UPDATE = 'pulp/propertySearch/UPDATE';

export const initialState = {
  propertyId: null,
  singleLineAddress: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE:
      return {...state, ...action.payload};
    default:
      return state;
  }
}

export function updatePropertySearch(propertySearch) {
  return {
    type: UPDATE,
    payload: propertySearch
  };
}
